import { Chip } from "@mui/material";

const STATUS_THEMES = {
  active: { bg: "#ECFDF5", text: "#059669", border: "#A7F3D0" },
  inactive: { bg: "#F3F4F6", text: "#6B7280", border: "#D1D5DB" },
  reached: { bg: "#EFF6FF", text: "#2563EB", border: "#BFDBFE" },
  completed: { bg: "#ECFDF5", text: "#059669", border: "#A7F3D0" },
  error: { bg: "#FEE2E2", text: "#DC2626", border: "#FECACA" },
};

const DEFAULT_THEME = { bg: "#F3F4F6", text: "#6B7280", border: "#D1D5DB" };

const formatLabel = (raw) => {
  if (!raw) return "active";
  if (raw.startsWith("ai.")) return raw.split(".").pop();
  return raw;
};

/**
 * Reusable status pill for displaying entity status.
 *
 * Props:
 *  - status: raw status string
 *  - sx: additional sx overrides
 */
const StatusPill = ({ status, sx: sxProp, ...props }) => {
  const label = formatLabel(status);
  const colors = STATUS_THEMES[label] || DEFAULT_THEME;

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        height: 20,
        fontSize: 10,
        fontWeight: 600,
        backgroundColor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
        ...sxProp,
      }}
      {...props}
    />
  );
};

export default StatusPill;
